export const TaskStatus = {
	BOOKED: 1,
	STARTED: 2,
	COMPLETED: 3,
	DEVIATION: 4,
};


export const TaskStatusNames = {
	[TaskStatus.BOOKED]: "Booked",
	[TaskStatus.STARTED]: "Started",
	[TaskStatus.COMPLETED]: "Completed",
	[TaskStatus.DEVIATION]: "Deviation",
}
